import angular from 'angular';
import templatesComponent from './templates.component';
import TemplatesService from './templates.service';
import templatesConfig from './templates.config';
import templateDetailModule from './template-detail/template-detail';

let templatesModule = angular.module('app.templates',[templateDetailModule.name])
  .component('templates', templatesComponent)
  .service('TemplatesService', TemplatesService)
  .config(templatesConfig);

export default templatesModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/templates/templates.js
 **/